((document, window) => {
    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;
	let resizeWindow;

    (resizeWindow = () => {
		window.addEventListener('resize', () => {
			if (window.innerWidth !== windowWidth || window.innerHeight !== windowHeight) {
				// Update the window height and width for next time
				windowWidth = window.innerWidth;
				windowHeight = window.innerHeight;

				const vh = window.innerHeight * 0.01;
				const vw = window.innerWidth * 0.01;
				document.documentElement.style.setProperty('--vh', `${ vh }px`);
				document.documentElement.style.setProperty('--vw', `${ vw }px`);
			}
		});
	})();

	if (typeof window !== 'undefined') {
		const vh = window.innerHeight * 0.01;
		const vw = window.innerWidth * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', `${ vh }px`);
		document.documentElement.style.setProperty('--vw', `${ vw }px`);
	}
})(document, window);